import gql from 'graphql-tag';

export const recentlyViewedIntegrationItemKindFragment = gql`
  fragment recentlyViewedIntegrationItemKindFragment on RecentlyViewedIntegrationItemKind {
    dokkioClass
    integrationItemKind
    lastViewedAt
  }
`;
export default recentlyViewedIntegrationItemKindFragment;
